import DOMPurify from 'dompurify';

const allowedTags = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'p',
  'br',
  'strong',
  'b',
  'em',
  'i',
  'u',
  'ul',
  'ol',
  'li',
  'a',
];

const allowedAttributes = ['href', 'title'];

export const createSafeHtml = value => ({
  __html: DOMPurify.sanitize(String(value ?? ''), {
    ALLOWED_TAGS: allowedTags,
    ALLOWED_ATTR: allowedAttributes,
  }),
});
